// Copyright (C) 2013 Minted Inc.
// All Rights Reserved
var module; UMD(module, {
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:m': ['M']
})(this, function(_, m_module) {

var M = m_module.M
M = M || {};
M.Url = M.Url || {};

M.Url.getWindowUrl = function() {
  return window.location.href;
};

M.Url.setWindowUrl = function(url) {
  window.location.href = url;
};

M.Url.ParseUrl = function(uri) {
    //https://gist.github.com/jlong/2428561
    var parser = document.createElement('a');
    parser.href = uri;

    var pathname = parser.pathname;

    // IE has a bug where pathname omits the leading '/'. If uri is a Location
    // object or an absolute url string, add the '/' back in.
    var isAbsolute = (uri.href || uri.charAt(0) === '/');
    if (isAbsolute && pathname.charAt(0) !== '/') {
      pathname = '/' + pathname;
    }

    // Hack for IE: When URLs contain a '#', parser.search does not return the
    // query string.
    var queryString = parser.search || parser.hash || '';
    queryString = queryString.substr(queryString.indexOf('?') + 1);

    return {
      a: parser,
      protocol: parser.protocol,
      hostname: parser.hostname,
      port: parser.port,
      pathname: pathname,
      search: parser.search,
      hash: parser.hash,
      host: parser.host,
      query: M.Url.ParseQuery(queryString)
    };
};

M.Url.UnparseUrl = function (url) {
  url.search = M.Url.UnparseQuery(url.query);
  // We could use the url.a.href to get the url, but that's not testable
  // on nodejs.
  return url.protocol.replace(/^([^:]*):?$/, '$1://') +
    url.hostname +
    (url.port ? ':' + url.port : '') +
    url.pathname +
    (url.search ? url.search.replace(/^\??(.*)$/, '?$1') : '') +
    (url.hash ? url.hash.replace(/^#?(.*)$/, '#$1') : '');
};

/**
 * Returns a copy of a url with the given key/value pairs set in the
 * query string.
 *
 * @param {string} url, The URL to add the params to.
 * @param {string} key, The get parameter key.
 * @param {string} value, The get parameter value.
 * @return {string} The full url with the new query string.
 */
M.Url.SetParam = function(url, key, value) {
  var parser = M.Url.ParseUrl(url);
  parser.query[key] = value;
  return M.Url.UnparseUrl(parser);
};

/**
 * Breaks up a url query into key value pairs.
 *
 * @param {string} queryString, e.g. key=value1&key=value2&a=b
 * @return {dict} params, e.g. {key: [value1, value2], a: b}
 */
M.Url.ParseQuery = function(queryString) {
  var params = {};
  if (queryString) {
    _.each(queryString.split(/^\?|&/g), function(el, i) {
      var pair = el.split('=');
      if (pair.length == 2) {
        var key = decodeURIComponent(pair[0]);
        var val = decodeURIComponent(pair[1]);
        if (params.hasOwnProperty(key)) {
            // If there exists a value of this key already and it is not an
            // array, make it an array.
            if (!_.isArray(params[key])) {
              params[key] = [params[key]];
            }
            params[key].push(val);
        } else {
          params[key] = val;
        }
      }
    });
  }
  return params;
};

M.Url.parseCurrentQuery = function () {
  return M.Url.ParseQuery(window.location.search);
};

/**
 * Takes a queryString that was broken into parts, and puts
 * it back together.
 *
 * @param {dict} queryParts, e.g. {key: [value1, value2], a: b}
 * @return {string} query string, e.g. 'key=value1&key=value2&a=b'
 */
M.Url.UnparseQuery = function(queryParts, sort) {
  var keys = _.keys(queryParts);

  if (sort) {
    keys = keys.sort();
  }
  return _.chain(keys).map(function(key) {
    key = encodeURIComponent(key);
    var value = queryParts[key];
    if (!_.isArray(value)) {
      value = [value];
    }
    if (sort) {
      value = value.sort();
    }
    return _.chain(value).map(function(arrayValue) {
      if (arrayValue) {
        return key + '=' + encodeURIComponent(arrayValue);
      } else {
        return null;
      }
    }).compact().value().join('&'); // Ignore null values before joining.
  }).compact().value().join('&');
};

/**
 * Set a parameter on a url based on whether a condition passes or fails.
 */
M.Url.setParamIf = function(url, condition, param, passValue, failValue) {
  var queryString = url.split('?')[1] || '';
  var query = M.Url.ParseQuery(queryString);
  if (condition) {
    query[param] = passValue;
  } else {
    query[param] = failValue;
  }
  queryString = M.Url.UnparseQuery(query);
  // Combine the new query string with the filter URL.
  return url.split('?')[0] + '?' + queryString;
};

/**
 * Joins path parts together
 *
 * M.Url.joinPaths('a', '/b/', '/c') === 'a/b/c'
 *
 * Takes any number of arguments and joins them into a path string.
 */
M.Url.joinPaths = (function () {
  var re_urlTrailingPath = /\/$/;
  var re_urlLeadingPath = /^\//;
  return function () {
    var result = '';
    _.each(arguments, function (part) {
      if (!result) {
        result = part;
      } else {
        result = result.replace(re_urlTrailingPath, '/') +
          part.replace(re_urlLeadingPath, '');
      }
    });
    return result;
  };
})();

M.Url.HandleRedirect = function(newUrl) {
  window.location = newUrl;
};

M.Url.RedirectToLogin = function() {
  window.location = '/login?destination=' +
    encodeURIComponent(window.location);
};

return {};
});
